const USER_KEY = "user_id";
const EMAIL_KEY = "user_email";
const ACCESS_TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";

const LEGACY_ACCESS_TOKEN_KEY = "auth_token"; // legacy or external key
const LEGACY_USER_KEY = "auth_user";         // not used, but reserved for future migration

export function getUserId() {
  try {
    return localStorage.getItem(USER_KEY);
  } catch {
    return null;
  }
}

export function setUser(userId, email) {
  try {
    if (userId != null) localStorage.setItem(USER_KEY, String(userId));
    if (email) localStorage.setItem(EMAIL_KEY, String(email));
  } catch {}
}

export function clearUser() {
  try {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(EMAIL_KEY);
  } catch {}
}

export function getUserEmail() {
  try {
    return localStorage.getItem(EMAIL_KEY);
  } catch {
    return null;
  }
}

export function setTokens(accessToken, refreshToken) {
  try {
    if (accessToken) {
      localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
      // Write legacy key for compatibility with other parts of the app (e.g., middleware)
      localStorage.setItem(LEGACY_ACCESS_TOKEN_KEY, accessToken);
    }
    if (refreshToken) localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  } catch {}
}

export function getAccessToken() {
  try {
    const v = localStorage.getItem(ACCESS_TOKEN_KEY);
    if (v) return v;
    // Fallback to legacy/external key if present
    return localStorage.getItem(LEGACY_ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getRefreshToken() {
  try {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function clearTokens() {
  try {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(LEGACY_ACCESS_TOKEN_KEY);
  } catch {}
}

// Clear all locally persisted auth/session data (tokens, user ids, onboarding progress)
export function clearAuthState() {
  try {
    clearTokens();
    clearUser();
  } catch {}
  try {
    sessionStorage.removeItem('user_id');
    sessionStorage.removeItem('onboarding_progress');
  } catch {}
}

// One-time soft migration: if only the legacy token exists, mirror it to ACCESS_TOKEN_KEY
try {
  const modern = localStorage.getItem(ACCESS_TOKEN_KEY);
  const legacy = localStorage.getItem(LEGACY_ACCESS_TOKEN_KEY);
  if (!modern && legacy) {
    localStorage.setItem(ACCESS_TOKEN_KEY, legacy);
  }
} catch {}
